import { IPractice } from '@principle-theorem/principle-core/interfaces';
import {
  FactTables,
  reactivationNonHealthFundPatientsCampaignReportTemplate,
} from '@principle-theorem/reporting';
import { DocumentReference, Region } from '@principle-theorem/shared';
import { IMarketingCampaignTemplate } from './marketing-campaign-template';
import { getReactivationPatientsCampaignTemplate } from './reactivation-nz-campaign-template';

// TODO: This is the same as the health fund one? Just the report is slightly different? This means patients could be targeted twice, once before a healthfund card is added and once afterwards?
export function getReactivationNonHealthFundPatientsCampaignTemplate(
  practiceRef: DocumentReference<IPractice>
): IMarketingCampaignTemplate {
  const template = getReactivationPatientsCampaignTemplate(practiceRef);
  return {
    ...template,
    name: 'Reactivation Non Health Fund Patients (12-24 Months No Visit)',
    description: `A campaign targeting non-health fund patients who haven't visited in 12-24 months, encouraging them to book an appointment and maintain their oral health.`,
    regions: [Region.Australia],
    campaign: {
      ...template.campaign,
      name: 'Reactivation Non Health Fund Patients (12-24 Months No Visit)',
    },
    report: reactivationNonHealthFundPatientsCampaignReportTemplate(
      FactTables.patientEvent.latestEvent
    ),
  };
}
